// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthorHeader-cls1__e4af3b353c2b6a6a1c6d{/*!*/}.AuthorHeader-cls2___66ff57e4a4d74b4a74a{clip-path:circle(48% at 50% 50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AuthorHeader-cls1__e4af3b353c2b6a6a1c6d",
	"cls2": "AuthorHeader-cls2___66ff57e4a4d74b4a74a AuthorHeader-cls1__e4af3b353c2b6a6a1c6d"
};
export default ___CSS_LOADER_EXPORT___;
